<div @backdroopFadeIn class="sopo-popup-backdrop" *ngIf="!outAnimation" (click)="backdropDismiss()" [ngClass]="{ 'sopo-popup-clickable-backdrop': settings.backdropDismiss, 'sopo-popup-side-betting-backdrop': sideBetting  }"></div>
<div *ngIf="!closing" @popupShootUp (@popupShootUp.done)="animationDone($event)" (@popupShootUp.start)="outAnimationStarted($event)" class="now-opening sopo-popup-container scrollable" [ngStyle]="style" [class]="settings.sCss">
    <div class="close-circle clickable" *ngIf="closeButton">
        <ion-icon class="close" name="close-circle-sharp" (click)="dismiss()"></ion-icon>
    </div>
    <div class="inserted-component-wrapper" [ngClass]="{'disable-scroll': settings.disableScroll}">
        <ng-container #insertionPoint></ng-container>
    </div>
</div>
